class CustomScrollSpy {
  constructor() {
    this.topNavItems = document.querySelectorAll('.nav-item');
    this.topNavWrapper = document.querySelector('.custom-sticky-nav-wrapper');
    this.topNavContainer = document.getElementById('nav-scroll-container');

    this.sideNavWrapper = null;
    this.sideNavItems = [];

    this.headerHeight = 0;
    this.totalStickyTop = 0;
    
    // 主题原有的 header 元素
    this.themeHeader = document.querySelector('#header');
    this.headerSection = document.querySelector('.header-section');
    this.originalHeaderSectionStyles = null;
    this.headerObserver = null;
    
    // 记录导航原始位置
    this.navWrapperOriginalTop = 0;
    this.navWrapperHeight = 0;
    this.isFixed = false;
    this.placeholder = null;
    this.scrollTicking = false;

    if (this.topNavItems.length && this.topNavWrapper) {
      this.init();
    }
  }

  init() {
    this.calculateStickyTop();
    this.createPlaceholder();
    this.captureOriginalPosition();
    
    // 初始化横向滚动功能
    this.initHorizontalScroll();
    
    // 强制禁用 header-section 的 sticky 效果
    this.forceDisableHeaderSticky();
    
    // 启动 MutationObserver 持续监控 header 变化
    this.startHeaderObserver();

    this.handleSideNavResponsive();

    this.bindClickEvents();
    this.bindScrollEvents();

    window.addEventListener('resize', () => {
      this.calculateStickyTop();
      this.captureOriginalPosition();
      this.handleSideNavResponsive();
      this.handleScroll();
    });
    
    // 初始检查
    setTimeout(() => {
      this.captureOriginalPosition();
      this.handleScroll();
    }, 100);
  }

  createPlaceholder() {
    this.placeholder = document.createElement('div');
    this.placeholder.className = 'custom-sticky-nav-placeholder';
    this.placeholder.style.display = 'none';
    this.placeholder.style.width = '100%';
    this.topNavWrapper.parentNode.insertBefore(this.placeholder, this.topNavWrapper.nextSibling);
  }

  captureOriginalPosition() {
    if (!this.isFixed) {
      const rect = this.topNavWrapper.getBoundingClientRect();
      this.navWrapperOriginalTop = rect.top + window.pageYOffset;
      this.navWrapperHeight = rect.height;
    }
  }

  // 初始化横向滚动功能
  initHorizontalScroll() {
    if (!this.topNavContainer) return;
    
    this.topNavContainer.style.overflowX = 'auto';
    this.topNavContainer.style.overflowY = 'visible';
    this.topNavContainer.style.scrollBehavior = 'smooth';
    this.topNavContainer.style.WebkitOverflowScrolling = 'touch';
    
    this.createScrollButtons();
    this.observeActiveItem();
  }

  // 创建左右滚动按钮
  createScrollButtons() {
    if (this.topNavWrapper.querySelector('.nav-scroll-btn')) return;
    
    const leftBtn = document.createElement('button');
    leftBtn.className = 'nav-scroll-btn nav-scroll-left';
    leftBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 18l-6-6 6-6"/></svg>';
    leftBtn.setAttribute('aria-label', 'Scroll left');
    
    const rightBtn = document.createElement('button');
    rightBtn.className = 'nav-scroll-btn nav-scroll-right';
    rightBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18l6-6-6-6"/></svg>';
    rightBtn.setAttribute('aria-label', 'Scroll right');
    
    const checkOverflow = () => {
      if (!this.topNavContainer) return;
      const hasOverflow = this.topNavContainer.scrollWidth > this.topNavContainer.clientWidth;
      leftBtn.style.display = hasOverflow ? 'flex' : 'none';
      rightBtn.style.display = hasOverflow ? 'flex' : 'none';
    };
    
    const updateButtonState = () => {
      if (!this.topNavContainer) return;
      const scrollLeft = this.topNavContainer.scrollLeft;
      const maxScroll = this.topNavContainer.scrollWidth - this.topNavContainer.clientWidth;
      
      leftBtn.style.opacity = scrollLeft <= 0 ? '0.3' : '1';
      leftBtn.style.pointerEvents = scrollLeft <= 0 ? 'none' : 'auto';
      
      rightBtn.style.opacity = scrollLeft >= maxScroll - 1 ? '0.3' : '1';
      rightBtn.style.pointerEvents = scrollLeft >= maxScroll - 1 ? 'none' : 'auto';
    };
    
    leftBtn.addEventListener('click', () => {
      this.topNavContainer.scrollBy({ left: -200, behavior: 'smooth' });
    });
    
    rightBtn.addEventListener('click', () => {
      this.topNavContainer.scrollBy({ left: 200, behavior: 'smooth' });
    });
    
    this.topNavContainer.addEventListener('scroll', updateButtonState);
    
    const resizeObserver = new ResizeObserver(() => {
      checkOverflow();
      updateButtonState();
    });
    resizeObserver.observe(this.topNavContainer);
    
    this.topNavWrapper.style.position = 'relative';
    this.topNavWrapper.appendChild(leftBtn);
    this.topNavWrapper.appendChild(rightBtn);
    
    setTimeout(() => {
      checkOverflow();
      updateButtonState();
    }, 100);
  }

  // 监听活动项变化，自动滚动到可视区域
  observeActiveItem() {
    const originalSetActive = this.setActive.bind(this);
    this.setActive = (id) => {
      originalSetActive(id);
      
      const activeItem = Array.from(this.topNavItems).find(item => item.dataset.target === id);
      if (activeItem && this.topNavContainer) {
        this.scrollToItem(activeItem);
      }
    };
  }

  // 滚动到指定项
  scrollToItem(item) {
    if (!item || !this.topNavContainer) return;
    
    const containerRect = this.topNavContainer.getBoundingClientRect();
    const itemRect = item.getBoundingClientRect();
    
    const itemLeft = itemRect.left - containerRect.left + this.topNavContainer.scrollLeft;
    const itemRight = itemLeft + itemRect.width;
    const containerWidth = this.topNavContainer.clientWidth;
    const scrollLeft = this.topNavContainer.scrollLeft;
    
    if (itemLeft < scrollLeft) {
      this.topNavContainer.scrollTo({ left: itemLeft - 20, behavior: 'smooth' });
    } else if (itemRight > scrollLeft + containerWidth) {
      this.topNavContainer.scrollTo({ left: itemRight - containerWidth + 20, behavior: 'smooth' });
    }
  }

  // 强制禁用 header-section 的 sticky 效果
  forceDisableHeaderSticky() {
    if (!this.headerSection) {
      this.headerSection = document.querySelector('.header-section');
      if (!this.headerSection) return;
    }

    this.originalHeaderSectionStyles = {
      position: this.headerSection.style.position,
      top: this.headerSection.style.top,
      left: this.headerSection.style.left,
      right: this.headerSection.style.right,
      width: this.headerSection.style.width,
      zIndex: this.headerSection.style.zIndex
    };

    this.applyHeaderNonStickyStyles();
    this.headerSection.classList.add('header-sticky-disabled');
    
    if (this.themeHeader) {
      this.themeHeader.classList.remove('is-sticky');
      this.themeHeader.classList.remove('header-sticky--active');
      this.themeHeader.classList.add('header-sticky-disabled-by-nav');
    }
  }

  applyHeaderNonStickyStyles() {
    if (!this.headerSection) return;
    
    this.headerSection.style.setProperty('position', 'relative', 'important');
    this.headerSection.style.setProperty('top', 'auto', 'important');
    this.headerSection.style.setProperty('left', 'auto', 'important');
    this.headerSection.style.setProperty('right', 'auto', 'important');
    this.headerSection.style.setProperty('z-index', '40', 'important');
  }

  startHeaderObserver() {
    if (!this.headerSection) return;
    
    this.headerObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes') {
          const attrName = mutation.attributeName;
          
          if (attrName === 'class') {
            this.headerSection.classList.add('header-sticky-disabled');
            if (this.themeHeader) {
              this.themeHeader.classList.remove('is-sticky');
              this.themeHeader.classList.remove('header-sticky--active');
            }
          }
          
          if (attrName === 'style') {
            const currentPosition = this.headerSection.style.position;
            if (currentPosition === 'sticky' || currentPosition === 'fixed') {
              this.applyHeaderNonStickyStyles();
            }
          }
        }
      });
    });
    
    this.headerObserver.observe(this.headerSection, {
      attributes: true,
      attributeFilter: ['class', 'style']
    });
    
    if (this.themeHeader) {
      this.headerObserver.observe(this.themeHeader, {
        attributes: true,
        attributeFilter: ['class', 'style']
      });
    }
  }

  stopHeaderObserver() {
    if (this.headerObserver) {
      this.headerObserver.disconnect();
      this.headerObserver = null;
    }
  }

  restoreThemeHeaderStyles() {
    if (this.headerSection) {
      this.stopHeaderObserver();
      
      this.headerSection.style.position = this.originalHeaderSectionStyles?.position || '';
      this.headerSection.style.top = this.originalHeaderSectionStyles?.top || '';
      this.headerSection.style.left = this.originalHeaderSectionStyles?.left || '';
      this.headerSection.style.right = this.originalHeaderSectionStyles?.right || '';
      this.headerSection.style.width = this.originalHeaderSectionStyles?.width || '';
      this.headerSection.style.zIndex = this.originalHeaderSectionStyles?.zIndex || '';
      
      this.headerSection.classList.remove('header-sticky-disabled');
    }
    
    if (this.themeHeader) {
      this.themeHeader.classList.remove('header-sticky-disabled-by-nav');
      this.themeHeader.classList.add('is-sticky');
      this.themeHeader.classList.add('header-sticky--active');
    }
  }

  createSideNav() {
    const shouldShow = this.topNavWrapper.dataset.showSideNav === 'true';
    if (!shouldShow || window.innerWidth <= 1024) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'custom-side-nav-wrapper';

    const container = document.createElement('div');
    container.className = 'side-nav-container';

    this.topNavItems.forEach(item => {
      const sideItem = document.createElement('div');
      sideItem.className = 'nav-item side-nav-item';
      sideItem.dataset.target = item.dataset.target;

      sideItem.innerHTML = `
        <div class="side-nav-indicator"></div>
        <div class="side-nav-text">${item.innerText}</div>
      `;

      container.appendChild(sideItem);
    });

    wrapper.appendChild(container);
    document.body.appendChild(wrapper);

    this.sideNavWrapper = wrapper;
    this.sideNavItems = wrapper.querySelectorAll('.side-nav-item');
  }

  handleSideNavResponsive() {
    const shouldShow = this.topNavWrapper.dataset.showSideNav === 'true';
    const isMobile = window.innerWidth <= 1024;

    if (!shouldShow || isMobile) {
      if (this.sideNavWrapper) {
        this.sideNavWrapper.remove();
        this.sideNavWrapper = null;
        this.sideNavItems = [];
      }
    } else {
      if (!this.sideNavWrapper) {
        this.createSideNav();
        this.bindClickEvents();
      }
    }
  }

  calculateStickyTop() {
    const header = this.headerSection || this.themeHeader || document.querySelector('.site-header');
    this.headerHeight = header ? header.offsetHeight : 0;

    const manualOffset = parseInt(this.topNavWrapper.dataset.manualOffset) || 0;
    this.totalStickyTop = manualOffset;
  }

  bindClickEvents() {
    const allItems = [...this.topNavItems, ...this.sideNavItems];

    allItems.forEach(item => {
      item.onclick = null;

      item.addEventListener('click', () => {
        const target = document.getElementById(item.dataset.target);
        if (!target) return;

        const navHeight = this.navWrapperHeight;
        
        // 计算滚动偏移
        let offset = this.totalStickyTop;
        if (this.isFixed) {
          offset += navHeight;
        }

        const y = target.getBoundingClientRect().top 
          + window.pageYOffset 
          - offset 
          - 20;

        window.scrollTo({
          top: y,
          behavior: 'smooth'
        });
      });
    });
  }

  setActive(id) {
    [...this.topNavItems, ...this.sideNavItems].forEach(el => {
      el.classList.toggle('active', el.dataset.target === id);
    });
  }

  handleScroll() {
    const scrollPos = window.pageYOffset;
    
    // 更新原始位置（如果未固定）
    if (!this.isFixed) {
      const rect = this.topNavWrapper.getBoundingClientRect();
      this.navWrapperOriginalTop = rect.top + scrollPos;
      this.navWrapperHeight = rect.height;
    }
    
    // 获取 header 高度
    const header = this.headerSection || this.themeHeader || document.querySelector('.site-header');
    const currentHeaderHeight = header ? header.offsetHeight : 0;
    
    // 关键修改：当导航的顶部刚好到达视口顶部（即滚动距离等于导航原始位置）时才固定
    // 这样导航就会在刚好接触到视口顶部时固定，而不是提前固定
    const threshold = this.navWrapperOriginalTop;
    
    // 判断是否应该固定 - 只有当导航顶部到达视口顶部时才固定
    if (scrollPos >= threshold && !this.isFixed) {
      this.fixNavigation();
    } else if (scrollPos < threshold && this.isFixed) {
      this.unfixNavigation();
    }
    
    // 更新活动项
    this.updateActiveItem(scrollPos);
    
    // 处理侧边栏可见性 - 仅在固定后才显示
    this.handleSideNavVisibility(scrollPos);
  }

  fixNavigation() {
    if (this.isFixed) return;
    
    this.isFixed = true;
    
    // 设置占位元素
    this.placeholder.style.display = 'block';
    this.placeholder.style.height = this.navWrapperHeight + 'px';
    
    // 固定导航 - 固定在视口顶部
    this.topNavWrapper.style.position = 'fixed';
    this.topNavWrapper.style.top = this.totalStickyTop + 'px';
    this.topNavWrapper.style.left = '0';
    this.topNavWrapper.style.width = '100%';
    this.topNavWrapper.style.zIndex = '50';
    this.topNavWrapper.style.boxShadow = '0 4px 10px rgba(0,0,0,0.05)';
  }

  unfixNavigation() {
    if (!this.isFixed) return;
    
    this.isFixed = false;
    
    // 隐藏占位元素
    this.placeholder.style.display = 'none';
    this.placeholder.style.height = '0px';
    
    // 恢复导航
    this.topNavWrapper.style.position = '';
    this.topNavWrapper.style.top = '';
    this.topNavWrapper.style.left = '';
    this.topNavWrapper.style.width = '';
    this.topNavWrapper.style.zIndex = '';
    this.topNavWrapper.style.boxShadow = '';
    
    // 更新位置信息
    setTimeout(() => {
      this.captureOriginalPosition();
      // 隐藏侧边栏
      if (this.sideNavWrapper) {
        this.sideNavWrapper.classList.remove('is-visible');
      }
    }, 10);
  }

  updateActiveItem(scrollPos) {
    const navHeight = this.navWrapperHeight;
    const offset = navHeight + this.totalStickyTop + 100;
    
    let currentId = '';

    this.topNavItems.forEach(item => {
      const target = document.getElementById(item.dataset.target);
      if (!target) return;

      const targetTop = target.getBoundingClientRect().top + scrollPos;

      if (scrollPos >= targetTop - offset) {
        currentId = item.dataset.target;
      }
    });

    if (currentId) {
      this.setActive(currentId);
    }
  }

  handleSideNavVisibility(scrollPos) {
    if (!this.sideNavWrapper) return;
    
    // 只有当导航固定后，并且滚动超过一定距离才显示侧边栏
    if (this.isFixed && scrollPos > window.innerHeight * 0.3) {
      this.sideNavWrapper.classList.add('is-visible');
    } else {
      this.sideNavWrapper.classList.remove('is-visible');
    }
  }

  bindScrollEvents() {
    window.addEventListener('scroll', () => {
      if (!this.scrollTicking) {
        window.requestAnimationFrame(() => {
          this.handleScroll();
          this.scrollTicking = false;
        });
        this.scrollTicking = true;
      }
    });
  }
  
  destroy() {
    this.restoreThemeHeaderStyles();
    
    if (this.placeholder && this.placeholder.parentNode) {
      this.placeholder.parentNode.removeChild(this.placeholder);
    }
    
    if (this.sideNavWrapper) {
      this.sideNavWrapper.remove();
      this.sideNavWrapper = null;
      this.sideNavItems = [];
    }
    
    const leftBtn = this.topNavWrapper?.querySelector('.nav-scroll-left');
    const rightBtn = this.topNavWrapper?.querySelector('.nav-scroll-right');
    if (leftBtn) leftBtn.remove();
    if (rightBtn) rightBtn.remove();
    
    if (this.topNavWrapper) {
      this.topNavWrapper.style.position = '';
      this.topNavWrapper.style.top = '';
      this.topNavWrapper.style.left = '';
      this.topNavWrapper.style.width = '';
      this.topNavWrapper.style.zIndex = '';
      this.topNavWrapper.style.boxShadow = '';
    }
  }
}

let customScrollSpyInstance = null;

function initCustomScrollSpy() {
  const navWrapper = document.querySelector('.custom-sticky-nav-wrapper');
  if (navWrapper) {
    if (customScrollSpyInstance) {
      customScrollSpyInstance.destroy();
    }
    customScrollSpyInstance = new CustomScrollSpy();
  }
}

document.addEventListener('DOMContentLoaded', initCustomScrollSpy);

document.addEventListener('shopify:section:load', (event) => {
  setTimeout(() => {
    const section = document.getElementById(`shopify-section-${event.detail.sectionId}`);
    if (section && section.querySelector('.custom-sticky-nav-wrapper')) {
      if (customScrollSpyInstance) {
        customScrollSpyInstance.destroy();
      }
      customScrollSpyInstance = new CustomScrollSpy();
    }
  }, 100);
});

document.addEventListener('shopify:section:unload', (event) => {
  const section = document.getElementById(`shopify-section-${event.detail.sectionId}`);
  if (section && section.querySelector('.custom-sticky-nav-wrapper')) {
    if (customScrollSpyInstance) {
      customScrollSpyInstance.destroy();
      customScrollSpyInstance = null;
    }
  }
  
  setTimeout(() => {
    const anyNavWrapper = document.querySelector('.custom-sticky-nav-wrapper');
    if (!anyNavWrapper) {
      const headerSection = document.querySelector('.header-section');
      const themeHeader = document.querySelector('#header');
      
      if (headerSection) {
        headerSection.classList.remove('header-sticky-disabled');
        headerSection.style.position = '';
        headerSection.style.top = '';
        headerSection.style.left = '';
        headerSection.style.zIndex = '';
      }
      
      if (themeHeader) {
        themeHeader.classList.remove('header-sticky-disabled-by-nav');
        themeHeader.classList.add('is-sticky');
        themeHeader.classList.add('header-sticky--active');
      }
    }
  }, 100);
});

document.addEventListener('shopify:block:select', () => {
  setTimeout(() => {
    if (customScrollSpyInstance) {
      customScrollSpyInstance.destroy();
      customScrollSpyInstance = new CustomScrollSpy();
    }
  }, 100);
});

document.addEventListener('shopify:block:deselect', () => {
  setTimeout(() => {
    if (customScrollSpyInstance) {
      customScrollSpyInstance.destroy();
      customScrollSpyInstance = new CustomScrollSpy();
    }
  }, 100);
});